import { render, staticRenderFns } from "./SerialCounterDisplay.vue?vue&type=template&id=2b3a605c&scoped=true&"
import script from "./SerialCounterDisplay.vue?vue&type=script&lang=ts&"
export * from "./SerialCounterDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./SerialCounterDisplay.vue?vue&type=style&index=0&id=2b3a605c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b3a605c",
  null
  
)

export default component.exports